import { createAction, props } from '@ngrx/store';
// Interfaces
import { IUser } from '@shared/interfaces/user.interface';

// Listar Usuarios action
export const LOAD_USERS = createAction('[USERS] Cargar Lista de Usuarios');

// Devuelve la lista de usuarios si se obtuvieron correctamente
export const LOAD_USERS_SUCCESS = createAction('[USERS] Listar Usuarios Success', props<{ users: IUser[] }>());

// Devuelve el error si no se logran obtener los cargos
export const LOAD_USERS_ERROR = createAction('[USERS] Listar Usuarios Error', props<{ payload: any }>());
